import { lazy } from 'react';

const AffiliateLeads = lazy(() => import('../../admin/affiliate-leads/AffiliateLeadsPage'));

const ManagerAffiliateLeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/affiliate-leads',
      element: <AffiliateLeads />,
    },
  ],
};

export default ManagerAffiliateLeadsConfig;
